import { Link, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { TesterManager } from "@/components/TesterManager";
export default function AdminSupport() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_platform_admin) return <Navigate to="/" replace />;
  return <main className="min-h-screen bg-background px-4 py-8"><div className="max-w-5xl mx-auto space-y-6">
    <Link to="/impostazioni" className="underline">Torna a K9 Manager</Link>
    <header><h1 className="font-head text-2xl font-bold">Admin / Support</h1><p className="text-muted-foreground">Account e accessi dei centri K9 Manager</p></header>
    <TesterManager />
  </div></main>;
}
